import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["information_text"];
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box, IconTooltip, Tooltip } from '@applyboard/ui-components';
import { CheckMarkOutlineIcon, WarningFillIcon } from '@applyboard/ui-icons';
import CopyButton from "../../../../../components/CopyButton";
import useInitialProps from "../../../../../hooks/useInitialProps";
import { _SidebarStudentInfoWrapper } from "../../styles";
import { CheckEligibilityButton } from "../../../../../components/CheckEligibilityButton";
import { usePageSettings } from "../../../PageSettings";
import { fullName } from "../../../../../util/fullName";
function StudentRow(_ref) {
  var _initialProps$permiss, _application$student, _application$student2, _application$program;
  var application = _ref.application,
    info = _ref.info,
    hasPermission = _ref.hasPermission;
  var initialProps = useInitialProps();
  var studentName = info.first_name || info.last_name ? fullName(info) : 'Name not available';
  var showIds = hasPermission('show_ids');
  var canViewBackgroundInformation = showIds && hasPermission('view_background_information');
  var showCheckEligibilityButton = initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$permiss = initialProps.permissions) === null || _initialProps$permiss === void 0 ? void 0 : _initialProps$permiss.can_check_eligibility;

  // Temporary solution until the student profile page is added to the school SPA
  // https://applyboard.atlassian.net/browse/SCH-72
  var _usePageSettings = usePageSettings(),
    appName = _usePageSettings.appName;
  var isSchoolApp = appName === 'school';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_SidebarStudentInfoWrapper, null, !!info.studentId && /*#__PURE__*/React.createElement(Box, {
    component: "span",
    mr: 1
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Student ID"
  }, info.studentId)), /*#__PURE__*/React.createElement("span", null, "|"), /*#__PURE__*/React.createElement(Box, {
    component: isSchoolApp ? 'span' : 'a',
    ml: 1,
    href: !isSchoolApp && info.profileLink
  }, studentName), canViewBackgroundInformation && /*#__PURE__*/React.createElement(StudentIcon, {
    intent: hasAnsweredNoToAllBackgroundQuestions(application === null || application === void 0 ? void 0 : (_application$student = application.student) === null || _application$student === void 0 ? void 0 : _application$student.background_information) ? 'positive' : 'warning',
    label: "Background Information",
    title: hasAnsweredNoToAllBackgroundQuestions(application === null || application === void 0 ? void 0 : (_application$student2 = application.student) === null || _application$student2 === void 0 ? void 0 : _application$student2.background_information) ? 'Student has answered no to all background questions.' : application.student.background_information.information_text
  }), showIds && /*#__PURE__*/React.createElement(CopyButton, {
    label: studentName,
    dataCy: "copy-student-name",
    tooltip: "Click to copy student's name",
    successMessage: "Copied student's name"
  })), showCheckEligibilityButton && /*#__PURE__*/React.createElement(CheckEligibilityButton, {
    programId: application === null || application === void 0 ? void 0 : (_application$program = application.program) === null || _application$program === void 0 ? void 0 : _application$program.id,
    studentId: info.studentId
  }));
}
function StudentIcon(_ref2) {
  var intent = _ref2.intent,
    label = _ref2.label,
    title = _ref2.title;
  var icon;
  switch (intent) {
    case 'positive':
      icon = /*#__PURE__*/React.createElement(CheckMarkOutlineIcon, {
        intent: intent
      });
      break;
    case 'warning':
      icon = /*#__PURE__*/React.createElement(WarningFillIcon, {
        intent: intent
      });
  }
  return /*#__PURE__*/React.createElement(IconTooltip, {
    "aria-label": label,
    icon: icon,
    title: title
  });
}
function hasAnsweredNoToAllBackgroundQuestions(backgroundInformation) {
  if (!backgroundInformation) return true;
  var information_text = backgroundInformation.information_text,
    booleanProperties = _objectWithoutProperties(backgroundInformation, _excluded); // eslint-disable-line @typescript-eslint/no-unused-vars
  return Object.values(booleanProperties).every(function (value) {
    return !value;
  });
}
export default StudentRow;